import React from "react";
import { geoCentroid } from "d3-geo";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  Annotation,
} from "react-simple-maps";

import allStates from "./allstates.json";
import "./LocationMap.scss";
import styled from "styled-components";
const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const offsets = {
  VT: [50, -8],
  NH: [34, 2],
  MA: [30, -1],
  RI: [28, 2],
  CT: [35, 10],
  NJ: [34, 1],
  DE: [33, 0],
  MD: [47, 10],
  DC: [49, 21],
};

const cmlStates = [
  "TX",
  "CA",
  "AZ",
  "NV",
  "OK",
  "TN",
  "NC",
  "GA",
  "AL",
  "FL",
  "OH",
  "PA",
  "NY",
  "NJ",
  "CT",
  "RI",
  "ME",
  "MA",
];
const cmlStateNames = [
  "Texas",
  "California",
  "Arizona",
  "Nevada",
  "Oklahoma",
  "Tennessee",
  "North Carolina",
  "Georgia",
  "Alabama",
  "Florida",
  "Ohio",
  "Pennsylvania",
  "New York",
  "New Jersey",
  "Connecticut",
  "Rhode Island",
  "Maine",
  "Massachusetts",
];
const CMLGeo = styled(Geography)`
  stroke: rgb(212, 33, 44);
  fill: rgb(255, 237, 238);
  cursor: pointer;
  &:hover {
    fill: rgb(255, 237, 238);
    color: #fff;
  }
`;
const LocationMap = () => {
  return (
    <ComposableMap projection="geoAlbersUsa">
      <Geographies geography={geoUrl}>
        {({ geographies }) => (
          <>
            {geographies.map((geo) => {
              if (
                geo.properties.name === "Alaska" ||
                geo.properties.name === "Hawaii"
              )
                if (cmlStateNames.includes(geo.properties.name)) {
                  return (
                    <CMLGeo
                      className={`cml-state cml-state-${geo.rsmKey}`}
                      key={geo.rsmKey}
                      geography={geo}
                    />
                  );
                }
              return (
                <Geography
                  key={geo.rsmKey}
                  stroke="#DDD"
                  fill="#FFF"
                  geography={geo}
                />
              );
            })}
            {geographies.map((geo) => {
              const centroid = geoCentroid(geo);
              const cur = allStates.find((s) => s.val === geo.id);
              if (!cmlStates.includes(cur.id)) return null;
              return (
                <g key={geo.rsmKey + "-name"}>
                  {cur &&
                    centroid[0] > -160 &&
                    centroid[0] < -67 &&
                    (Object.keys(offsets).indexOf(cur.id) === -1 ? (
                      <Marker coordinates={centroid}>
                        <text y="2" fontSize={14} textAnchor="middle">
                          {cur.id}
                        </text>
                      </Marker>
                    ) : (
                      <Annotation
                        className=""
                        subject={centroid}
                        dx={offsets[cur.id][0]}
                        dy={offsets[cur.id][1]}
                      >
                        <text x={4} fontSize={14} alignmentBaseline="middle">
                          {cur.id}
                        </text>
                      </Annotation>
                    ))}
                </g>
              );
            })}
          </>
        )}
      </Geographies>
    </ComposableMap>
  );
};

export default LocationMap;
